import React, { useContext, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import { TranslationContext } from "../contexts/TranslationContext";

const Success = () => {
  const navigate = useNavigate();
  const { translations } = useContext(TranslationContext);

  useEffect(() => {
    const token = localStorage.getItem("token");
    console.log("Token found:", token); // Debugging line
  
    if (!token) {
      console.log("No token found, redirecting to login");
      navigate("/se-connecter");
    }
  }, [navigate]);
  

  return (
    <>
      <Helmet>
        <title>{translations.congratsMsg} - O.A.V.L.I.T.E</title>
      </Helmet>
      <div className="navbar-header container-fluid px-5 mt-0 mb-5">
        <div className="w-100"></div>
        <div className="text-center logo-wrapper pt-3">
          <Link to="/" className="logo-link">
            <img
              src="../images/oavlite-black.png"
              className="img-fluid mx-auto text-center d-block d-logo mb-3"
              alt="oavlite"
            />
          </Link>
          <p className="mb-2 tagline__1">
            {translations.taglineV1} 
          </p>
           <p className="fw-500 tagline__3">{translations.tagline3}</p>
        </div>
      </div>
      <div className="content-wrapper text-center">
        <div className="container">
          <div className="center-content">
            <a href="/accueil" className="oavlite-text-primary mb-0 fw-600 d-block badge-light bg-white p-3 px-md-4 py-md-4 rounded-3 tagline-badge mb-5">
            {translations.goToMain}
            </a>
            <p className="mb-3">{translations.congratsMsg}</p>
          </div>
        </div>
      </div>

      <footer className="text-center d-footer">
        <p> <Link className="text-black" to="/cgu">CGU</Link></p>
      </footer>
    </>
  );
};

export default Success;
